import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initI18n } from '@hsc/i18n';
import './styles/global.css';

// Точка входа admin-app. i18n инициализируется до рендера, как в manager-web.
async function bootstrap(): Promise<void> {
  await initI18n({ fallbackLng: 'ru', lng: 'ru', loadPath: '/locales' });
  const el = document.getElementById('root');
  if (!el) throw new Error('admin-app: #root not found in DOM');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
